const MutationTypes = {
  // 开发者权限列表
  RESOURCE_PERMISSION_LIST: 'RESOURCE_PERMISSION_LIST',
  COMPANY_INFO: 'COMPANY_INFO',
  DEVDEFAULTVX: 'DEVDEFAULTVX'
}

export default MutationTypes



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js